import '../../less/registration-candidate.less';
import RecoveryStatus from './RecoveryStatus';
import RegistrationCode422 from './codes/RegistrationCode422';

export default class CandidateRecovery extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { status, custom, modalProps, failureCallback } = this.props;

        switch(status) {
            default: return <RecoveryStatus {...this.props} />;
        }
    }
}